import React from 'react';
import { Facebook, Twitter, MessageCircle, Link2, Check } from 'lucide-react';
import { useState } from 'react';

const SocialShare = ({ url, title, description }) => {
  const [copied, setCopied] = useState(false);
  
  const shareUrl = encodeURIComponent(url || window.location.href);
  const shareTitle = encodeURIComponent(title || document.title);
  const shareDescription = encodeURIComponent(description || '');

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`,
    whatsapp: `https://wa.me/?text=${shareTitle}%20${shareUrl}`,
  };

  const handleShare = (platform) => {
    const link = shareLinks[platform];
    window.open(link, '_blank', 'width=600,height=400,menubar=no,toolbar=no');
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url || window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm font-medium text-gray-600 mr-2">Share:</span>
      
      {/* Facebook */}
      <button
        onClick={() => handleShare('facebook')}
        className="p-2.5 bg-[#1877F2] hover:bg-[#166FE5] text-white rounded-full transition-all duration-200 hover:scale-110 shadow-md"
        title="Share on Facebook"
        aria-label="Share on Facebook"
      >
        <Facebook className="w-5 h-5" />
      </button>

      {/* Twitter/X */}
      <button
        onClick={() => handleShare('twitter')}
        className="p-2.5 bg-[#1DA1F2] hover:bg-[#1A94DA] text-white rounded-full transition-all duration-200 hover:scale-110 shadow-md"
        title="Share on Twitter"
        aria-label="Share on Twitter"
      >
        <Twitter className="w-5 h-5" />
      </button>

      {/* WhatsApp */}
      <button
        onClick={() => handleShare('whatsapp')}
        className="p-2.5 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full transition-all duration-200 hover:scale-110 shadow-md"
        title="Share on WhatsApp"
        aria-label="Share on WhatsApp"
      >
        <MessageCircle className="w-5 h-5" />
      </button>

      {/* Copy Link */}
      <button
        onClick={copyToClipboard}
        className={`p-2.5 rounded-full transition-all duration-200 hover:scale-110 shadow-md ${
          copied 
            ? 'bg-green-500 text-white' 
            : 'bg-gray-600 hover:bg-gray-700 text-white'
        }`}
        title={copied ? 'Copied!' : 'Copy link'}
        aria-label="Copy link to clipboard"
      >
        {copied ? <Check className="w-5 h-5" /> : <Link2 className="w-5 h-5" />}
      </button>
    </div>
  );
};

export default SocialShare;
